import './index.scss';
import 'antd-mobile/lib/toast/style/css';
import Toast from 'antd-mobile/lib/toast';
import './toast.scss';
import * as React from 'react';
import classnames from 'classnames';
import { EduVerifyCode } from '@tencent/edu-verify-code';
import {
  preventSyntheticEvent,
  tdwReportUtil,
  verifySmsCode,
} from '../../lib/utils';
import TextInput from '../FormTextInput';
import { INPUT_TYPE_MAP, INPUT_VERIFY_MAP } from '../FormTextInput/types';
import { EmptyData } from '../../lib/components/EmptyData';

const appId = '2071124753';
const EduVerifyCodeIns = new EduVerifyCode(appId);
const sendCode = async (phone, sendVoice = false) => {
  let result;
  try {
    result = EduVerifyCodeIns.getCode({
      app_id: 'k12',
      scene: 'k12_login',
      code_type: sendVoice ? 'voice' : 'text',
      nation_code: '86',
      phone_number: phone.toString(),
    });
  } catch (e) {
    result = Promise.reject({ retcode: 1 });
  }
  return result;
};

function getSmsCode(phone) {
  return sendCode(phone);
}

function getVerifyCode(phone, sendVoice = false) {
  return sendCode(phone, sendVoice);
}

class VerifyCode extends React.Component {
  phoneInputProps = {
    label: '手机号',
    type: INPUT_TYPE_MAP.number,
    verify: INPUT_VERIFY_MAP.phone,
    withMaxLength: true,
    maxLength: 11,
    required: true,
  };

  verifyInputProps = {
    label: '验证码',
    type: INPUT_TYPE_MAP.number,
    withMaxLength: true,
    maxLength: 6,
    required: true,
  };

  timer = null;

  voiceTimer = null;

  state = {
    phone: {},
    code: {},
    countdown: null,
    voiceCountdown: null,
    showVoiceVerifyInfo: false,
    codeType: 'text',
  };

  componentWillUnmount() {
    window.clearInterval(this.timer);
  }

  onPhoneChange = phone => {
    this.setState({ phone });
    this.props.setFormValue({ ...phone });
  };

  onCodeChange = code => {
    this.setState({ code });
    this.props.setFormValue({ ...code, beforeSubmit: this.beforeSubmit });
  };

  beforeSubmit = async () => {
    const { phone, code, codeType } = this.state;
    const valid = await verifySmsCode(phone.value, code.value, codeType);
    if (!valid) {
      Toast.hide();
      Toast.fail('验证码错误');
    }
    return valid;
  };

  sendCode = async e => {
    preventSyntheticEvent(e);

    const { phone, countdown } = this.state;
    const {
      failWording,
      successWording,
      disableVoiceVerify = true,
    } = this.props.data;

    if (!phone.valid || typeof countdown === 'number') {
      return;
    }
    Toast.loading('发送中', 0);
    this.setState({ codeType: 'text' });

    tdwReportUtil({
      event: 'click',
      module: this.props.parentModuleName || 'form_verify_code',
      position: 'send_code',
    });

    try {
      let res;
      if (disableVoiceVerify) {
        res = await getSmsCode(phone.value);
      } else {
        res = await getVerifyCode(phone.value);
      }
      if (res.retcode !== 0) {
        throw new Error('请求失败');
      }
    } catch (e) {
      console.error(e);
      Toast.hide();
      Toast.fail(failWording);
      return;
    }

    Toast.hide();
    Toast.success(successWording);
    return this.setState({ countdown: this.props.data.timeout }, () => {
      this.timer = setInterval(this.timerCallback, 1000);
    });
  };

  getVoiceCode = async e => {
    const { phone, voiceCountdown } = this.state;
    const { failWording } = this.props.data;

    if (phone.valid) {
      preventSyntheticEvent(e);
    }

    if (!phone.valid || typeof voiceCountdown === 'number') {
      return;
    }
    Toast.loading('发送中', 0);
    this.setState({ codeType: 'voice' });

    tdwReportUtil({
      event: 'click',
      module: this.props.parentModuleName || 'form_verify_code',
      position: 'send_voice_code',
    });

    let res;
    try {
      res = await getVerifyCode(phone.value, true);
    } catch (e) {
      console.error(e);
      Toast.fail(failWording);
      return;
    }

    Toast.hide();
    if (res.retcode === 0) {
      Toast.info(
        <span className="fudao-get-voice-code-toast">
          我们将拨打
          <span> {phone.value}</span>
          <br />
          发送语音验证码
        </span>
      );
      return this.setState({ voiceCountdown: this.props.data.timeout }, () => {
        this.voiceTimer = setInterval(this.voiceTimerCallback, 1000);
      });
    }
    Toast.info(
      <span className="fudao-get-voice-code-toast">发送语音验证码失败</span>
    );
  };

  timerCallback = () => {
    const { countdown } = this.state;

    if (typeof countdown !== 'number') {
      return;
    }

    if (countdown === 1) {
      this.setState({ countdown: null });
      window.clearInterval(this.timer);
      this.timer = null;
      return;
    }

    if (countdown <= 30) {
      this.setState({ showVoiceVerifyInfo: true });
    }

    this.setState({ countdown: countdown - 1 });
  };

  voiceTimerCallback = () => {
    const { voiceCountdown } = this.state;

    if (typeof voiceCountdown !== 'number') {
      return;
    }

    if (voiceCountdown === 1) {
      this.setState({ voiceCountdown: null });
      window.clearInterval(this.voiceTimer);
      this.voiceTimer = null;
      return;
    }

    this.setState({ voiceCountdown: voiceCountdown - 1 });
  };

  renderGetCodeButton = () => {
    const { countdown, phone } = this.state;
    const showCountdown = typeof countdown === 'number';

    if (showCountdown) {
      return (
        <button className="fudao-verify-button">
          {countdown}
          秒后重发
        </button>
      );
    }

    return (
      <button
        onClick={this.sendCode}
        className={classnames('fudao-verify-button', { valid: phone.valid })}
      >
        发送验证码
      </button>
    );
  };

  renderGetVoiceCodeNode = () => {
    const { disableVoiceVerify = true } = this.props.data;
    if (disableVoiceVerify) {
      return null;
    }

    const { voiceCountdown, phone } = this.state;
    const showCountdown = typeof voiceCountdown === 'number';

    if (showCountdown) {
      return (
        <span className="fudao-get-voice-code">
          {voiceCountdown}
          秒后重发
        </span>
      );
    }

    if (!this.state.showVoiceVerifyInfo) {
      return null;
    }

    return (
      <span
        onClick={this.getVoiceCode}
        className={classnames('fudao-get-voice-code', { valid: phone.valid })}
      >
        <span>
          <span className="hide-on-small">收不到短信？</span>
          获取语音验证码
        </span>
      </span>
    );
  };

  render() {
    const { showVerifyInfo = false, setFormValue, phoneTip } = this.props;

    if (!setFormValue) {
      return <EmptyData text="该组件只能作为[辅导表单容器]的子组件" />;
    }

    return (
      <div className="fudao-verify-input">
        <TextInput
          data={
            phoneTip
              ? { ...this.phoneInputProps, tip: phoneTip }
              : this.phoneInputProps
          }
          setFormValue={this.onPhoneChange}
          showVerifyInfo={showVerifyInfo}
          subNode={this.renderGetCodeButton()}
          afterNode={this.renderGetVoiceCodeNode()}
          background={this.props.background}
          scrollAfterBlur={this.props.scrollAfterBlur}
        />
        <TextInput
          data={this.verifyInputProps}
          setFormValue={this.onCodeChange}
          showVerifyInfo={showVerifyInfo}
          warnText={this.props.codeWarnText}
          background={this.props.background}
          scrollAfterBlur={this.props.scrollAfterBlur}
        />
      </div>
    );
  }
}

export default VerifyCode;
